function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return generator._invoke = function (innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; }(innerFn, self, context), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == typeof value && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; this._invoke = function (method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); }; } function maybeInvokeDelegate(delegate, context) { var method = delegate.iterator[context.method]; if (undefined === method) { if (context.delegate = null, "throw" === context.method) { if (delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method)) return ContinueSentinel; context.method = "throw", context.arg = new TypeError("The iterator does not provide a 'throw' method"); } return ContinueSentinel; } var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) { if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; } return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, define(Gp, "constructor", GeneratorFunctionPrototype), define(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (object) { var keys = []; for (var key in object) { keys.push(key); } return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) { "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); } }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, catch: function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }

!function (t, n) {
  "object" == typeof exports && "object" == typeof module ? module.exports = n() : "function" == typeof define && define.amd ? define([], n) : "object" == typeof exports ? exports.ColorPlugin = n() : t.ColorPlugin = n();
}(window, function () {
  return function (t) {
    var n = {};

    function e(o) {
      if (n[o]) return n[o].exports;
      var r = n[o] = {
        i: o,
        l: !1,
        exports: {}
      };
      return t[o].call(r.exports, r, r.exports, e), r.l = !0, r.exports;
    }

    return e.m = t, e.c = n, e.d = function (t, n, o) {
      e.o(t, n) || Object.defineProperty(t, n, {
        enumerable: !0,
        get: o
      });
    }, e.r = function (t) {
      "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(t, Symbol.toStringTag, {
        value: "Module"
      }), Object.defineProperty(t, "__esModule", {
        value: !0
      });
    }, e.t = function (t, n) {
      if (1 & n && (t = e(t)), 8 & n) return t;
      if (4 & n && "object" == typeof t && t && t.__esModule) return t;
      var o = Object.create(null);
      if (e.r(o), Object.defineProperty(o, "default", {
        enumerable: !0,
        value: t
      }), 2 & n && "string" != typeof t) for (var r in t) {
        e.d(o, r, function (n) {
          return t[n];
        }.bind(null, r));
      }
      return o;
    }, e.n = function (t) {
      var n = t && t.__esModule ? function () {
        return t.default;
      } : function () {
        return t;
      };
      return e.d(n, "a", n), n;
    }, e.o = function (t, n) {
      return Object.prototype.hasOwnProperty.call(t, n);
    }, e.p = "/", e(e.s = 2);
  }([function (t, n, e) {
    "use strict";

    e.r(n), e.d(n, "handleCSSVariables", function () {
      return r;
    }), e.d(n, "throttle", function () {
      return i;
    }), e.d(n, "setDefaultColorCache", function () {
      return s;
    }), e.d(n, "getDefaultColorCache", function () {
      return c;
    }), e.d(n, "setCustomColorCache", function () {
      return l;
    }), e.d(n, "getCustomColorCache", function () {
      return a;
    });
    var o = "editor-js-text-color-cache";

    function r(t) {
      return function (t) {
        return n = t, ("string" == typeof n || n instanceof String) && t.includes("--");
        var n;
      }(t) ? function (t) {
        return window.getComputedStyle(document.documentElement).getPropertyValue(t);
      }(function (t) {
        var n = /\((.*?)\)/.exec(t);
        if (n) return n[1];
      }(t)) : t;
    }

    function i(t, n) {
      var e;
      return function () {
        for (var o = arguments.length, r = new Array(o), i = 0; i < o; i++) {
          r[i] = arguments[i];
        }

        e || (e = setTimeout(function () {
          t.apply(void 0, r), e = null;
        }, n));
      };
    }

    function s(t, n) {
      return sessionStorage.setItem("".concat(o, "-").concat(n), JSON.stringify(t)), t;
    }

    function c(t, n) {
      var e = sessionStorage.getItem("".concat(o, "-").concat(n));
      return e ? JSON.parse(e) : t;
    }

    function l(t, n) {
      sessionStorage.setItem("".concat(o, "-").concat(n, "-custom"), JSON.stringify(t));
    }

    function a(t) {
      var n = sessionStorage.getItem("".concat(o, "-").concat(t, "-custom"));
      return n ? JSON.parse(n) : null;
    }
  }, function (t, n, e) {
    var o = e(3);
    "string" == typeof o && (o = [[t.i, o, ""]]);
    var r = {
      hmr: !0,
      transform: void 0,
      insertInto: void 0
    };
    e(5)(o, r);
    o.locals && (t.exports = o.locals);
  }, function (t, n, e) {
    function o(t, n) {
      for (var e = 0; e < n.length; e++) {
        var o = n[e];
        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(t, o.key, o);
      }
    }

    var r = e(7),
        i = e(0),
        s = i.getDefaultColorCache,
        c = i.handleCSSVariables;
    e(1).toString();

    var l = function () {
      function t(n) {
        var e = n.config,
            o = n.api;
        !function (t, n) {
          if (!(t instanceof n)) throw new TypeError("Cannot call a class as a function");
        }(this, t), this.api = o, this.config = e, this.pluginType = this.config.type || "text", this.hasCustomPicker = this.config.customPicker || !1, this.color = c(s(this.config.defaultColor, this.pluginType)), this.button = null, this.iconClasses = {
          base: this.api.styles.inlineToolButton,
          active: this.api.styles.inlineToolButtonActive
        };
      }

      var n, e, i;
      return n = t, i = [{
        key: "isInline",
        get: function get() {
          return !0;
        }
      }, {
        key: "sanitize",
        get: function get() {
          return {
            font: !0,
            span: !0
          };
        }
      }], (e = [{
        key: "render",
        value: function value() {
          var t = this;
          this.button = document.createElement("button"), this.button.type = "button", this.button.classList.add("colorPlugin"), this.button.classList.add(this.iconClasses.base);
          var n = new r.ColorPlugin({
            onColorPicked: function onColorPicked(n) {
              t.color = n;
            },
            hasCustomPicker: this.hasCustomPicker,
            defaultColor: this.config.defaultColor,
            colorCollections: this.config.colorCollections,
            type: this.pluginType
          });
          return this.button.appendChild(n), this.button;
        }
      }, {
        key: "surround",
        value: function value(t) {
          "marker" === this.pluginType ? document.execCommand("backColor", !1, this.color) : document.execCommand("foreColor", !1, this.color);
        }
      }, {
        key: "checkState",
        value: function value() {}
      }]) && o(n.prototype, e), i && o(n, i), t;
    }();

    t.exports = l;
  }, function (t, n, e) {
    (t.exports = e(4)(!1)).push([t.i, ".picker_wrapper.popup {\n  z-index: 99;\n  width: 170px;\n  margin: 0;\n  box-shadow: 0 0 10px 1px #eaeaea;\n  background: #ffffff;\n}\n\n.picker_arrow {\n  display: none;\n}\n\n.layout_default .picker_slider, .layout_default .picker_selector {\n  padding: 5px;\n}\n\n.colorPlugin.ce-inline-tool {\n  width: 30px;\n  border-radius: 3px;\n}\n", ""]);
  }, function (t, n) {
    t.exports = function (t) {
      var n = [];
      return n.toString = function () {
        return this.map(function (n) {
          var e = function (t, n) {
            var e = t[1] || "",
                o = t[3];
            if (!o) return e;

            if (n && "function" == typeof btoa) {
              var r = (s = o, "/*# sourceMappingURL=data:application/json;charset=utf-8;base64," + btoa(unescape(encodeURIComponent(JSON.stringify(s)))) + " */"),
                  i = o.sources.map(function (t) {
                return "/*# sourceURL=" + o.sourceRoot + t + " */";
              });
              return [e].concat(i).concat([r]).join("\n");
            }

            var s;
            return [e].join("\n");
          }(n, t);

          return n[2] ? "@media " + n[2] + "{" + e + "}" : e;
        }).join("");
      }, n.i = function (t, e) {
        "string" == typeof t && (t = [[null, t, ""]]);

        for (var o = {}, r = 0; r < this.length; r++) {
          var i = this[r][0];
          "number" == typeof i && (o[i] = !0);
        }

        for (r = 0; r < t.length; r++) {
          var s = t[r];
          "number" == typeof s[0] && o[s[0]] || (e && !s[2] ? s[2] = e : e && (s[2] = "(" + s[2] + ") and (" + e + ")"), n.push(s));
        }
      }, n;
    };
  }, function (t, n, e) {
    var o,
        r,
        i = {},
        s = (o = function o() {
      return window && document && document.all && !window.atob;
    }, function () {
      return void 0 === r && (r = o.apply(this, arguments)), r;
    }),
        c = function c(t) {
      return document.querySelector(t);
    },
        l = function (t) {
      var n = {};
      return function (t) {
        if ("function" == typeof t) return t();

        if (void 0 === n[t]) {
          var e = c.call(this, t);
          if (window.HTMLIFrameElement && e instanceof window.HTMLIFrameElement) try {
            e = e.contentDocument.head;
          } catch (t) {
            e = null;
          }
          n[t] = e;
        }

        return n[t];
      };
    }(),
        a = null,
        u = 0,
        p = [],
        d = e(6);

    function f(t, n) {
      for (var e = 0; e < t.length; e++) {
        var o = t[e],
            r = i[o.id];

        if (r) {
          r.refs++;

          for (var s = 0; s < r.parts.length; s++) {
            r.parts[s](o.parts[s]);
          }

          for (; s < o.parts.length; s++) {
            r.parts.push(v(o.parts[s], n));
          }
        } else {
          var c = [];

          for (s = 0; s < o.parts.length; s++) {
            c.push(v(o.parts[s], n));
          }

          i[o.id] = {
            id: o.id,
            refs: 1,
            parts: c
          };
        }
      }
    }

    function h(t, n) {
      for (var e = [], o = {}, r = 0; r < t.length; r++) {
        var i = t[r],
            s = n.base ? i[0] + n.base : i[0],
            c = {
          css: i[1],
          media: i[2],
          sourceMap: i[3]
        };
        o[s] ? o[s].parts.push(c) : e.push(o[s] = {
          id: s,
          parts: [c]
        });
      }

      return e;
    }

    function b(t, n) {
      var e = l(t.insertInto);
      if (!e) throw new Error("Couldn't find a style target. This probably means that the value for the 'insertInto' parameter is invalid.");
      var o = p[p.length - 1];
      if ("top" === t.insertAt) o ? o.nextSibling ? e.insertBefore(n, o.nextSibling) : e.appendChild(n) : e.insertBefore(n, e.firstChild), p.push(n);else if ("bottom" === t.insertAt) e.appendChild(n);else {
        if ("object" != typeof t.insertAt || !t.insertAt.before) throw new Error("[Style Loader]\n\n Invalid value for parameter 'insertAt' ('options.insertAt') found.\n Must be 'top', 'bottom', or Object.\n (https://github.com/webpack-contrib/style-loader#insertat)\n");
        var r = l(t.insertInto + " " + t.insertAt.before);
        e.insertBefore(n, r);
      }
    }

    function y(t) {
      if (null === t.parentNode) return !1;
      t.parentNode.removeChild(t);
      var n = p.indexOf(t);
      n >= 0 && p.splice(n, 1);
    }

    function g(t) {
      var n = document.createElement("style");
      return void 0 === t.attrs.type && (t.attrs.type = "text/css"), m(n, t.attrs), b(t, n), n;
    }

    function m(t, n) {
      Object.keys(n).forEach(function (e) {
        t.setAttribute(e, n[e]);
      });
    }

    function v(t, n) {
      var e, o, r, i;

      if (n.transform && t.css) {
        if (!(i = n.transform(t.css))) return function () {};
        t.css = i;
      }

      if (n.singleton) {
        var s = u++;
        e = a || (a = g(n)), o = w.bind(null, e, s, !1), r = w.bind(null, e, s, !0);
      } else t.sourceMap && "function" == typeof URL && "function" == typeof URL.createObjectURL && "function" == typeof URL.revokeObjectURL && "function" == typeof Blob && "function" == typeof btoa ? (e = function (t) {
        var n = document.createElement("link");
        return void 0 === t.attrs.type && (t.attrs.type = "text/css"), t.attrs.rel = "stylesheet", m(n, t.attrs), b(t, n), n;
      }(n), o = A.bind(null, e, n), r = function r() {
        y(e), e.href && URL.revokeObjectURL(e.href);
      }) : (e = g(n), o = C.bind(null, e), r = function r() {
        y(e);
      });

      return o(t), function (n) {
        if (n) {
          if (n.css === t.css && n.media === t.media && n.sourceMap === t.sourceMap) return;
          o(t = n);
        } else r();
      };
    }

    t.exports = function (t, n) {
      if ("undefined" != typeof DEBUG && DEBUG && "object" != typeof document) throw new Error("The style-loader cannot be used in a non-browser environment");
      (n = n || {}).attrs = "object" == typeof n.attrs ? n.attrs : {}, n.singleton || "boolean" == typeof n.singleton || (n.singleton = s()), n.insertInto || (n.insertInto = "head"), n.insertAt || (n.insertAt = "bottom");
      var e = h(t, n);
      return f(e, n), function (t) {
        for (var o = [], r = 0; r < e.length; r++) {
          var s = e[r];
          (c = i[s.id]).refs--, o.push(c);
        }

        t && f(h(t, n), n);

        for (r = 0; r < o.length; r++) {
          var c;

          if (0 === (c = o[r]).refs) {
            for (var l = 0; l < c.parts.length; l++) {
              c.parts[l]();
            }

            delete i[c.id];
          }
        }
      };
    };

    var x,
        k = (x = [], function (t, n) {
      return x[t] = n, x.filter(Boolean).join("\n");
    });

    function w(t, n, e, o) {
      var r = e ? "" : o.css;
      if (t.styleSheet) t.styleSheet.cssText = k(n, r);else {
        var i = document.createTextNode(r),
            s = t.childNodes;
        s[n] && t.removeChild(s[n]), s.length ? t.insertBefore(i, s[n]) : t.appendChild(i);
      }
    }

    function C(t, n) {
      var e = n.css,
          o = n.media;
      if (o && t.setAttribute("media", o), t.styleSheet) t.styleSheet.cssText = e;else {
        for (; t.firstChild;) {
          t.removeChild(t.firstChild);
        }

        t.appendChild(document.createTextNode(e));
      }
    }

    function A(t, n, e) {
      var o = e.css,
          r = e.sourceMap,
          i = void 0 === n.convertToAbsoluteUrls && r;
      (n.convertToAbsoluteUrls || i) && (o = d(o)), r && (o += "\n/*# sourceMappingURL=data:application/json;base64," + btoa(unescape(encodeURIComponent(JSON.stringify(r)))) + " */");
      var s = new Blob([o], {
        type: "text/css"
      }),
          c = t.href;
      t.href = URL.createObjectURL(s), c && URL.revokeObjectURL(c);
    }
  }, function (t, n) {
    t.exports = function (t) {
      var n = "undefined" != typeof window && window.location;
      if (!n) throw new Error("fixUrls requires window.location");
      if (!t || "string" != typeof t) return t;
      var e = n.protocol + "//" + n.host,
          o = e + n.pathname.replace(/\/[^\/]*$/, "/");
      return t.replace(/url\s*\(((?:[^)(]|\((?:[^)(]+|\([^)(]*\))*\))*)\)/gi, function (t, n) {
        var r,
            i = n.trim().replace(/^"(.*)"$/, function (t, n) {
          return n;
        }).replace(/^'(.*)'$/, function (t, n) {
          return n;
        });
        return /^(#|data:|http:\/\/|https:\/\/|file:\/\/\/|\s*$)/i.test(i) ? t : (r = 0 === i.indexOf("//") ? i : 0 === i.indexOf("/") ? e + i : o + i.replace(/^\.\//, ""), "url(" + JSON.stringify(r) + ")");
      });
    };
  }, function (t, n, e) {
    "use strict";

    function o(t) {
      return (o = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
        return typeof t;
      } : function (t) {
        return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
      })(t);
    }

    function r(t, n) {
      if (!(t instanceof n)) throw new TypeError("Cannot call a class as a function");
    }

    function i(t, n) {
      for (var e = 0; e < n.length; e++) {
        var o = n[e];
        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(t, o.key, o);
      }
    }

    function s(t, n, e) {
      return n && i(t.prototype, n), e && i(t, e), t;
    }

    function c(t, n) {
      if ("function" != typeof n && null !== n) throw new TypeError("Super expression must either be null or a function");
      t.prototype = Object.create(n && n.prototype, {
        constructor: {
          value: t,
          writable: !0,
          configurable: !0
        }
      }), n && f(t, n);
    }

    function l(t) {
      var n = d();
      return function () {
        var e,
            o = h(t);

        if (n) {
          var r = h(this).constructor;
          e = Reflect.construct(o, arguments, r);
        } else e = o.apply(this, arguments);

        return a(this, e);
      };
    }

    function a(t, n) {
      return !n || "object" !== o(n) && "function" != typeof n ? function (t) {
        if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return t;
      }(t) : n;
    }

    function u(t) {
      var n = "function" == typeof Map ? new Map() : void 0;
      return (u = function u(t) {
        if (null === t || (e = t, -1 === Function.toString.call(e).indexOf("[native code]"))) return t;
        var e;
        if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function");

        if (void 0 !== n) {
          if (n.has(t)) return n.get(t);
          n.set(t, o);
        }

        function o() {
          return p(t, arguments, h(this).constructor);
        }

        return o.prototype = Object.create(t.prototype, {
          constructor: {
            value: o,
            enumerable: !1,
            writable: !0,
            configurable: !0
          }
        }), f(o, t);
      })(t);
    }

    function p(t, n, e) {
      return (p = d() ? Reflect.construct : function (t, n, e) {
        var o = [null];
        o.push.apply(o, n);
        var r = new (Function.bind.apply(t, o))();
        return e && f(r, e.prototype), r;
      }).apply(null, arguments);
    }

    function d() {
      if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
      if (Reflect.construct.sham) return !1;
      if ("function" == typeof Proxy) return !0;

      try {
        return Date.prototype.toString.call(Reflect.construct(Date, [], function () {})), !0;
      } catch (t) {
        return !1;
      }
    }

    function f(t, n) {
      return (f = Object.setPrototypeOf || function (t, n) {
        return t.__proto__ = n, t;
      })(t, n);
    }

    function h(t) {
      return (h = Object.setPrototypeOf ? Object.getPrototypeOf : function (t) {
        return t.__proto__ || Object.getPrototypeOf(t);
      })(t);
    }

    e.r(n), e.d(n, "ColorPlugin", function () {
      return V;
    });

    var b = function (t) {
      c(e, t);
      var n = l(e);

      function e() {
        var t;
        return r(this, e), (t = n.call(this)).attachShadow({
          mode: "open"
        }).innerHTML = '\n        <style>\n        :host{ \n            position:relative; \n            display:inline-flex; \n            padding: .25em .625em;\n            box-sizing:border-box; \n            vertical-align: middle;\n            line-height: 1.8;\n            width: 5px;\n            overflow:hidden; \n            align-items:center;\n            justify-content: center;\n            font-size: 14px; \n            color: var(--fontColor,#333);  \n            border-radius: var(--borderRadius,.25em);\n            background: var(--fontColor,#333); \n            transition:background .3s,box-shadow .3s,border-color .3s,color .3s;\n        }\n        :host([shape="circle"]){ \n            border-radius:50%; \n        }\n        /*\n        :host(:not([disabled]):active){\n            z-index:1;\n            transform:translateY(.1em);\n        }\n        */\n        :host([disabled]),:host([loading]){\n            pointer-events: none; \n            opacity:.6; \n        }\n        :host([block]){ \n            display:flex; \n        }\n        :host([disabled]:not([type])){ \n            background:rgba(0,0,0,.1); \n        }\n        :host([disabled]) .btn,:host([loading]) .btn{ \n            cursor: not-allowed; \n            pointer-events: all; \n        }\n        :host(:not([type="primary"]):not([type="danger"]):not([disabled]):hover),\n        :host(:not([type="primary"]):not([type="danger"]):focus-within),\n        :host([type="flat"][focus]){ \n            color:var(--themeColor,#42b983); \n            border-color: var(--themeColor,#42b983); \n        }\n        :host(:not([type="primary"]):not([type="danger"])) .btn::after{ \n            background-image: radial-gradient(circle, var(--themeColor,#42b983) 10%, transparent 10.01%); \n        }\n        :host([type="primary"]){ \n            color: #fff; \n            background:var(--themeBackground,var(--themeColor,#42b983));\n        }\n        :host([type="danger"]){ \n            color: #fff; \n            background:var(--themeBackground,var(--dangerColor,#ff7875));\n        }\n        :host([type="dashed"]){ \n            border-style:dashed \n        }\n        :host([type="flat"]),:host([type="primary"]),:host([type="danger"]){ \n            border:0;\n            padding: calc( .25em + 1px ) calc( .625em + 1px );\n        }\n        :host([type="flat"]) .btn::before{ \n            content:\'\'; \n            position:absolute; \n            background:var(--themeColor,#42b983);\n            pointer-events:none; \n            left:0; \n            right:0; \n            top:0; \n            bottom:0; \n            opacity:0; \n            transition:.3s;\n        }\n        :host([type="flat"]:not([disabled]):hover) .btn::before{ \n            opacity:.1 \n        }\n        :host(:not([disabled]):hover){ \n            z-index:1 \n        }\n        :host([type="flat"]:focus-within) .btn:before,\n        :host([type="flat"][focus]) .btn:before{ \n            opacity:.2; \n        }\n        :host(:focus-within){ \n            /*box-shadow: 0 0 10px rgba(0,0,0,0.1);*/ \n        }\n        .btn{ \n            background:none; \n            outline:0; \n            border:0; \n            position: \n            absolute; \n            left:0; \n            top:0;\n            width:100%;\n            height:100%;\n            padding:0;\n            user-select: none;\n            cursor: unset;\n        }\n        xy-loading{ \n            margin-right: 0.35em;  \n        }\n        ::-moz-focus-inner{\n            border:0;\n        }\n        .btn::before{\n            content: "";\n            display: block;\n            position: absolute;\n            width: 100%;\n            height: 100%;\n            left:0;\n            top:0;\n            transition:.2s;\n            background:#fff;\n            opacity:0;\n        }\n        :host(:not([disabled]):active) .btn::before{ \n            opacity:.2;\n        }\n        .btn::after {\n            content: "";\n            display: block;\n            position: absolute;\n            width: 100%;\n            height: 100%;\n            left: var(--x,0); \n            top: var(--y,0);\n            pointer-events: none;\n            background-image: radial-gradient(circle, #fff 10%, transparent 10.01%);\n            background-repeat: no-repeat;\n            background-position: 50%;\n            transform: translate(-50%,-50%) scale(10);\n            opacity: 0;\n            transition: transform .3s, opacity .8s;\n        }\n        .btn:not([disabled]):active::after {\n            transform: translate(-50%,-50%) scale(0);\n            opacity: .3;\n            transition: 0s;\n        }\n        xy-icon{\n            margin-right: 0.35em;\n            transition: none;\n        }\n        :host(:empty) xy-icon{\n            margin: auto;\n        }\n        :host(:empty){\n            padding: .65em;\n        }\n        :host([type="flat"]:empty),:host([type="primary"]:empty){ \n            padding: calc( .65em + 1px );\n        }\n        ::slotted(xy-icon){\n            transition: none;\n        }\n        :host([href]){\n            cursor:pointer;\n        }\n        </style>\n        <'.concat(t.href ? "a" : "button", " ").concat(t.htmltype ? 'type="' + t.htmltype + '"' : "", " ").concat(t.download && t.href ? 'download="' + t.download + '"' : "", " ").concat(t.href ? 'href="' + t.href + '" target="' + t.target + '" rel="' + t.rel + '"' : "", ' class="btn" id="btn"></').concat(t.href ? "a" : "button", ">").concat(!t.loading && t.icon && "null" != t.icon ? '<xy-icon id="icon" name=' + t.icon + "></xy-icon>" : "", "<slot></slot>\n        "), t;
      }

      return s(e, null, [{
        key: "observedAttributes",
        get: function get() {
          return ["disabled", "icon", "loading", "href", "htmltype"];
        }
      }]), s(e, [{
        key: "focus",
        value: function value() {
          this.btn.focus();
        }
      }, {
        key: "connectedCallback",
        value: function value() {
          this.btn = this.shadowRoot.getElementById("btn"), this.ico = this.shadowRoot.getElementById("icon"), this.load = document.createElement("xy-loading"), this.load.style.color = "inherit", this.btn.addEventListener("mousedown", function (t) {
            if (!this.disabled) {
              var n = this.getBoundingClientRect(),
                  e = n.left,
                  o = n.top;
              this.style.setProperty("--x", t.clientX - e + "px"), this.style.setProperty("--y", t.clientY - o + "px");
            }
          }), this.addEventListener("click", function (t) {
            this.toggle && (this.checked = !this.checked);
          }), this.btn.addEventListener("keydown", function (t) {
            switch (t.keyCode) {
              case 13:
                t.stopPropagation();
            }
          }), this.disabled = this.disabled, this.loading = this.loading;
        }
      }, {
        key: "attributeChangedCallback",
        value: function value(t, n, e) {
          "disabled" == t && this.btn && (null !== e ? (this.btn.setAttribute("disabled", "disabled"), this.href && this.btn.removeAttribute("href")) : (this.btn.removeAttribute("disabled"), this.href && (this.btn.href = this.href))), "loading" == t && this.btn && (null !== e ? (this.shadowRoot.prepend(this.load), this.btn.setAttribute("disabled", "disabled")) : (this.shadowRoot.removeChild(this.load), this.btn.removeAttribute("disabled"))), "icon" == t && this.ico && (this.ico.name = e), "href" == t && this.btn && (this.disabled || (this.btn.href = e)), "htmltype" == t && this.btn && (this.btn.type = e);
        }
      }, {
        key: "disabled",
        get: function get() {
          return null !== this.getAttribute("disabled");
        },
        set: function set(t) {
          null === t || !1 === t ? this.removeAttribute("disabled") : this.setAttribute("disabled", "");
        }
      }, {
        key: "toggle",
        get: function get() {
          return null !== this.getAttribute("toggle");
        }
      }, {
        key: "htmltype",
        get: function get() {
          return this.getAttribute("htmltype");
        },
        set: function set(t) {
          this.setAttribute("htmltype", t);
        }
      }, {
        key: "name",
        get: function get() {
          return this.getAttribute("name");
        }
      }, {
        key: "checked",
        get: function get() {
          return null !== this.getAttribute("checked");
        },
        set: function set(t) {
          null === t || !1 === t ? this.removeAttribute("checked") : this.setAttribute("checked", "");
        }
      }, {
        key: "href",
        get: function get() {
          return this.getAttribute("href");
        },
        set: function set(t) {
          this.setAttribute("href", t);
        }
      }, {
        key: "target",
        get: function get() {
          return this.getAttribute("target") || "_blank";
        }
      }, {
        key: "rel",
        get: function get() {
          return this.getAttribute("rel");
        }
      }, {
        key: "download",
        get: function get() {
          return this.getAttribute("download");
        }
      }, {
        key: "icon",
        get: function get() {
          return this.getAttribute("icon");
        },
        set: function set(t) {
          this.setAttribute("icon", t);
        }
      }, {
        key: "loading",
        get: function get() {
          return null !== this.getAttribute("loading");
        },
        set: function set(t) {
          null === t || !1 === t ? this.removeAttribute("loading") : this.setAttribute("loading", "");
        }
      }]), e;
    }(u(HTMLElement));

    customElements.get("xy-button") || customElements.define("xy-button", b);

    var y = function (t) {
      c(e, t);
      var n = l(e);

      function e() {
        var t;
        return r(this, e), (t = n.call(this)).attachShadow({
          mode: "open"
        }).innerHTML = '\n        <style>\n        :host {\n            display:inline-flex;\n        }\n        ::slotted(xy-button:not(:first-of-type):not(:last-of-type)){\n            border-radius:0;\n        }\n        ::slotted(xy-button){\n            margin:0!important;\n        }\n        ::slotted(xy-button:not(:first-of-type)){\n            margin-left:-1px!important;\n        }\n        ::slotted(xy-button[type]:not([type="dashed"]):not(:first-of-type)){\n            margin-left:1px!important;\n        }\n        ::slotted(xy-button:first-of-type){\n            border-top-right-radius: 0;\n            border-bottom-right-radius: 0px;\n        }\n        ::slotted(xy-button:last-of-type){\n            border-top-left-radius: 0;\n            border-bottom-left-radius: 0;\n        }\n        </style>\n        <slot></slot>\n        ', t;
      }

      return s(e, null, [{
        key: "observedAttributes",
        get: function get() {
          return ["disabled"];
        }
      }]), s(e, [{
        key: "connectedCallback",
        value: function value() {}
      }, {
        key: "attributeChangedCallback",
        value: function value(t, n, e) {}
      }, {
        key: "disabled",
        get: function get() {
          return null !== this.getAttribute("disabled");
        },
        set: function set(t) {
          null === t || !1 === t ? this.removeAttribute("disabled") : this.setAttribute("disabled", "");
        }
      }]), e;
    }(u(HTMLElement));

    function g(t) {
      return (g = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
        return typeof t;
      } : function (t) {
        return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
      })(t);
    }

    function m(t, n, e, o, r, i, s) {
      try {
        var c = t[i](s),
            l = c.value;
      } catch (t) {
        return void e(t);
      }

      c.done ? n(l) : Promise.resolve(l).then(o, r);
    }

    function v(t) {
      return function () {
        var n = this,
            e = arguments;
        return new Promise(function (o, r) {
          var i = t.apply(n, e);

          function s(t) {
            m(i, o, r, s, c, "next", t);
          }

          function c(t) {
            m(i, o, r, s, c, "throw", t);
          }

          s(void 0);
        });
      };
    }

    function x(t, n) {
      if (!(t instanceof n)) throw new TypeError("Cannot call a class as a function");
    }

    function k(t, n) {
      for (var e = 0; e < n.length; e++) {
        var o = n[e];
        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(t, o.key, o);
      }
    }

    function w(t, n, e) {
      return n && k(t.prototype, n), e && k(t, e), t;
    }

    function C(t, n) {
      if ("function" != typeof n && null !== n) throw new TypeError("Super expression must either be null or a function");
      t.prototype = Object.create(n && n.prototype, {
        constructor: {
          value: t,
          writable: !0,
          configurable: !0
        }
      }), n && j(t, n);
    }

    function A(t) {
      var n = P();
      return function () {
        var e,
            o = R(t);

        if (n) {
          var r = R(this).constructor;
          e = Reflect.construct(o, arguments, r);
        } else e = o.apply(this, arguments);

        return E(this, e);
      };
    }

    function E(t, n) {
      return !n || "object" !== g(n) && "function" != typeof n ? function (t) {
        if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return t;
      }(t) : n;
    }

    function S(t) {
      var n = "function" == typeof Map ? new Map() : void 0;
      return (S = function S(t) {
        if (null === t || (e = t, -1 === Function.toString.call(e).indexOf("[native code]"))) return t;
        var e;
        if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function");

        if (void 0 !== n) {
          if (n.has(t)) return n.get(t);
          n.set(t, o);
        }

        function o() {
          return O(t, arguments, R(this).constructor);
        }

        return o.prototype = Object.create(t.prototype, {
          constructor: {
            value: o,
            enumerable: !1,
            writable: !0,
            configurable: !0
          }
        }), j(o, t);
      })(t);
    }

    function O(t, n, e) {
      return (O = P() ? Reflect.construct : function (t, n, e) {
        var o = [null];
        o.push.apply(o, n);
        var r = new (Function.bind.apply(t, o))();
        return e && j(r, e.prototype), r;
      }).apply(null, arguments);
    }

    function P() {
      if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
      if (Reflect.construct.sham) return !1;
      if ("function" == typeof Proxy) return !0;

      try {
        return Date.prototype.toString.call(Reflect.construct(Date, [], function () {})), !0;
      } catch (t) {
        return !1;
      }
    }

    function j(t, n) {
      return (j = Object.setPrototypeOf || function (t, n) {
        return t.__proto__ = n, t;
      })(t, n);
    }

    function R(t) {
      return (R = Object.setPrototypeOf ? Object.getPrototypeOf : function (t) {
        return t.__proto__ || Object.getPrototypeOf(t);
      })(t);
    }

    customElements.get("xy-button-group") || customElements.define("xy-button-group", y);

    var T = function (t) {
      C(e, t);
      var n = A(e);

      function e(t) {
        var o;
        return x(this, e), (o = n.call(this)).attachShadow({
          mode: "open"
        }).innerHTML = '\n        <style>\n        :host{\n            position:absolute;\n            display:flex;\n            box-shadow: 2px 2px 15px rgba(0,0,0,0.15);\n            box-sizing: border-box;\n            transform:scale(0);\n            opacity:0.5;\n            border-radius: 3px;\n            z-index:10;\n            transition:.3s cubic-bezier(.645, .045, .355, 1);\n            transform-origin:inherit;\n            background:#fff;\n            visibility:hidden;\n        }\n        .popcon-content{\n            box-sizing: border-box;\n            display:flex;\n            width: max-content;\n            padding: 0 15px;\n            flex:1;\n            flex-direction:column;\n        }\n        .popcon-title {\n            line-height: 30px;\n            padding: 15px 30px 0 0;\n            font-weight: 700;\n            font-size: 14px;\n            color: #4c5161;\n            user-select: none;\n            cursor: default;\n        }\n        .popcon-body {\n            flex: 1;\n            padding: 5px 0 15px 0;\n        }\n        .popcon-footer {\n            padding: 3px 0 15px 0;\n            margin-top: -3px;\n            text-align: right;\n            white-space: nowrap;\n        }\n        .btn-close{\n            position:absolute;\n            right:10px;\n            top:10px;\n            border:0;\n        }\n        .popcon-footer xy-button {\n            font-size: .8em;\n            margin-left: .8em;\n        }\n        .popcon-type{\n            display:flex;\n            width:30px;\n            height:30px;\n            font-size:22px;\n            margin: 15px -10px 0 15px;\n        }\n        /*\n        :host(:not([type="confirm"])) .popcon-type,\n        :host(:not([type="confirm"])) .popcon-footer,\n        :host(:not([type])) .popcon-title,\n        :host(:not([type])) .btn-close{\n            display:none;\n        }\n        */\n        :host([type="confirm"]){\n            min-width:250px;\n        }\n        :host([type="confirm"]) .popcon-body{\n            font-size:14px;\n        }\n        :host(:not([type])) .popcon-content,:host(:not([type])) .popcon-body{\n            padding: 0;\n        }\n        </style>\n            '.concat("confirm" === (t || o.type) ? '<xy-icon id="popcon-type" class="popcon-type" name="question-circle" color="var(--waringColor,#faad14)"></xy-icon>' : "", '\n            <div class="popcon-content">\n                ').concat(null !== (t || o.type) ? '<div class="popcon-title" id="title">' + o.title + '</div><xy-button class="btn-close" id="btn-close" icon="close"></xy-button>' : "", '\n                <div class="popcon-body">\n                    <slot></slot>\n                </div>\n                ').concat("confirm" === (t || o.type) ? '<div class="popcon-footer"><xy-button id="btn-cancel">' + o.canceltext + '</xy-button><xy-button id="btn-submit" type="primary">' + o.oktext + "</xy-button></div>" : "", "\n            </div>\n        "), o;
      }

      return w(e, null, [{
        key: "observedAttributes",
        get: function get() {
          return ["open", "title", "oktext", "canceltext", "loading", "type"];
        }
      }]), w(e, [{
        key: "connectedCallback",
        value: function value() {
          var t = this;
          this.remove = !1, this.type && (this.titles = this.shadowRoot.getElementById("title"), this.btnClose = this.shadowRoot.getElementById("btn-close")), "confirm" == this.type && (this.btnCancel = this.shadowRoot.getElementById("btn-cancel"), this.btnSubmit = this.shadowRoot.getElementById("btn-submit")), this.addEventListener("transitionend", function (n) {
            "transform" === n.propertyName && t.open && ("confirm" == t.type && t.btnSubmit.focus(), "pane" == t.type && t.btnClose.focus(), t.dispatchEvent(new CustomEvent("open")));
          }), this.addEventListener("transitionend", function (n) {
            "transform" !== n.propertyName || t.open || (t.remove && t.parentNode.removeChild(t), t.dispatchEvent(new CustomEvent("close")));
          }), this.addEventListener("click", function (n) {
            n.target.closest("[autoclose]") && (t.open = !1, window.xyActiveElement.focus());
          }), this.type && this.btnClose.addEventListener("click", function () {
            t.open = !1, window.xyActiveElement.focus();
          }), "confirm" == this.type && (this.btnCancel.addEventListener("click", v(_regeneratorRuntime().mark(function n() {
            return _regeneratorRuntime().wrap(function (n) {
              for (;;) {
                switch (n.prev = n.next) {
                  case 0:
                    t.dispatchEvent(new CustomEvent("cancel")), t.open = !1, window.xyActiveElement.focus();

                  case 3:
                  case "end":
                    return n.stop();
                }
              }
            }, n);
          }))), this.btnSubmit.addEventListener("click", function () {
            t.dispatchEvent(new CustomEvent("submit")), t.loading || (t.open = !1, window.xyActiveElement.focus());
          }));
        }
      }, {
        key: "attributeChangedCallback",
        value: function value(t, n, e) {
          "open" == t && this.shadowRoot && null == e && this.stopfocus, "loading" == t && this.shadowRoot && (this.btnSubmit.loading = null !== e), "title" == t && this.titles && null !== e && (this.titles.innerHTML = e), "oktext" == t && this.btnSubmit && null !== e && (this.btnSubmit.innerHTML = e), "canceltext" == t && this.btnCancel && null !== e && (this.btnCancel.innerHTML = e);
        }
      }, {
        key: "open",
        get: function get() {
          return null !== this.getAttribute("open");
        },
        set: function set(t) {
          null === t || !1 === t ? (this.removeAttribute("open"), this.parentNode.removeAttribute("open")) : (this.setAttribute("open", ""), this.parentNode.setAttribute("open", ""), this.loading && (this.loading = !1));
        }
      }, {
        key: "stopfocus",
        get: function get() {
          return null !== this.getAttribute("stopfocus");
        }
      }, {
        key: "title",
        get: function get() {
          return this.getAttribute("title") || "popcon";
        },
        set: function set(t) {
          this.setAttribute("title", t);
        }
      }, {
        key: "type",
        get: function get() {
          return this.getAttribute("type");
        },
        set: function set(t) {
          null === t || !1 === t ? this.removeAttribute("type") : this.setAttribute("type", t);
        }
      }, {
        key: "oktext",
        get: function get() {
          return this.getAttribute("oktext") || "confirm";
        },
        set: function set(t) {
          this.setAttribute("oktext", t);
        }
      }, {
        key: "canceltext",
        get: function get() {
          return this.getAttribute("canceltext") || "cancel";
        },
        set: function set(t) {
          this.setAttribute("canceltext", t);
        }
      }, {
        key: "loading",
        get: function get() {
          return null !== this.getAttribute("loading");
        },
        set: function set(t) {
          null === t || !1 === t ? this.removeAttribute("loading") : this.setAttribute("loading", "");
        }
      }]), e;
    }(S(HTMLElement));

    customElements.get("xy-popcon") || customElements.define("xy-popcon", T);

    var L = function (t) {
      C(e, t);
      var n = A(e);

      function e() {
        var t;
        return x(this, e), (t = n.call(this)).attachShadow({
          mode: "open"
        }).innerHTML = '\n        <style>\n        :host {\n            display:inline-block;\n            position:relative;\n            overflow:visible;\n        }\n        :host([dir="top"]) ::slotted(xy-popcon){\n            bottom:100%;\n            left:50%;\n            transform:translate(-50%,-10px) scale(0);\n            transform-origin: center bottom;\n        }\n        :host([dir="top"]) ::slotted(xy-popcon[open]),\n        :host([dir="top"][trigger="hover"]:not([disabled]):hover) ::slotted(xy-popcon),\n        :host([dir="top"][trigger="focus"]:not([disabled]):focus-within) ::slotted(xy-popcon){\n            transform:translate(-50%,-10px) scale(1);\n        }\n        :host([dir="right"]) ::slotted(xy-popcon){\n            left:100%;\n            top:50%;\n            transform:translate(10px,-50%) scale(0);\n            transform-origin: left;\n        }\n        :host([dir="right"]) ::slotted(xy-popcon[open]),\n        :host([dir="right"][trigger="hover"]:not([disabled]):hover) ::slotted(xy-popcon),\n        :host([dir="right"][trigger="focus"]:not([disabled]):focus-within) ::slotted(xy-popcon){\n            transform:translate(10px,-50%) scale(1);\n        }\n        :host([dir="bottom"]) ::slotted(xy-popcon){\n            top:100%;\n            left:50%;\n            transform:translate(-50%,10px) scale(0);\n            transform-origin: center top;\n        }\n        :host([dir="bottom"]) ::slotted(xy-popcon[open]),\n        :host([dir="bottom"][trigger="hover"]:not([disabled]):hover) ::slotted(xy-popcon),\n        :host([dir="bottom"][trigger="focus"]:not([disabled]):focus-within) ::slotted(xy-popcon){\n            transform:translate(-50%,10px) scale(1);\n        }\n        :host([dir="left"]) ::slotted(xy-popcon){\n            right:100%;\n            top:50%;\n            transform:translate(-10px,-50%) scale(0);\n            transform-origin: right;\n        }\n        :host([dir="left"]) ::slotted(xy-popcon[open]),\n        :host([dir="left"][trigger="hover"]:not([disabled]):hover) ::slotted(xy-popcon),\n        :host([dir="left"][trigger="focus"]:not([disabled]):focus-within) ::slotted(xy-popcon){\n            transform:translate(-10px,-50%) scale(1);\n        }\n        :host([dir="lefttop"]) ::slotted(xy-popcon){\n            right:100%;\n            top:0;\n            transform:translate(-10px) scale(0);\n            transform-origin: right top;\n        }\n        :host([dir="lefttop"]) ::slotted(xy-popcon[open]),\n        :host([dir="lefttop"][trigger="hover"]:not([disabled]):hover) ::slotted(xy-popcon),\n        :host([dir="lefttop"][trigger="focus"]:not([disabled]):focus-within) ::slotted(xy-popcon){\n            transform:translate(-10px) scale(1);\n        }\n        :host([dir="leftbottom"]) ::slotted(xy-popcon){\n            right:100%;\n            bottom:0;\n            transform:translate(-10px) scale(0);\n            transform-origin: right bottom;\n        }\n        :host([dir="leftbottom"]) ::slotted(xy-popcon[open]),\n        :host([dir="leftbottom"][trigger="hover"]:not([disabled]):hover) ::slotted(xy-popcon),\n        :host([dir="leftbottom"][trigger="focus"]:not([disabled]):focus-within) ::slotted(xy-popcon){\n            transform:translate(-10px) scale(1);\n        }\n        :host([dir="topleft"]) ::slotted(xy-popcon){\n            bottom:100%;\n            left:0;\n            transform:translate(0,-10px) scale(0);\n            transform-origin: left bottom;\n        }\n        :host([dir="topleft"]) ::slotted(xy-popcon[open]),\n        :host([dir="topleft"][trigger="hover"]:not([disabled]):hover) ::slotted(xy-popcon),\n        :host([dir="topleft"][trigger="focus"]:not([disabled]):focus-within) ::slotted(xy-popcon){\n            transform:translate(0,-10px) scale(1);\n        }\n        :host([dir="topright"]) ::slotted(xy-popcon){\n            bottom:100%;\n            right:0;\n            transform:translate(0,-10px) scale(0);\n            transform-origin: right bottom;\n        }\n        :host([dir="topright"]) ::slotted(xy-popcon[open]),\n        :host([dir="topright"][trigger="hover"]:not([disabled]):hover) ::slotted(xy-popcon),\n        :host([dir="topright"][trigger="focus"]:not([disabled]):focus-within) ::slotted(xy-popcon){\n            transform:translate(0,-10px) scale(1);\n        }\n        :host([dir="righttop"]) ::slotted(xy-popcon){\n            left:100%;\n            top:0;\n            transform:translate(10px) scale(0);\n            transform-origin: left top;\n        }\n        :host([dir="righttop"]) ::slotted(xy-popcon[open]),\n        :host([dir="righttop"][trigger="hover"]:not([disabled]):hover) ::slotted(xy-popcon),\n        :host([dir="righttop"][trigger="focus"]:not([disabled]):focus-within) ::slotted(xy-popcon){\n            transform:translate(10px) scale(1);\n        }\n        :host([dir="rightbottom"]) ::slotted(xy-popcon){\n            left:100%;\n            bottom:0;\n            transform:translate(10px) scale(0);\n            transform-origin: left bottom;\n        }\n        :host([dir="rightbottom"]) ::slotted(xy-popcon[open]),\n        :host([dir="rightbottom"][trigger="hover"]:not([disabled]):hover) ::slotted(xy-popcon),\n        :host([dir="rightbottom"][trigger="focus"]:not([disabled]):focus-within) ::slotted(xy-popcon){\n            transform:translate(10px) scale(1);\n        }\n        :host([dir="bottomleft"]) ::slotted(xy-popcon),\n        :host(:not([dir])) ::slotted(xy-popcon){\n            left:0;\n            top:100%;\n            transform:translate(0,10px) scale(0);\n            transform-origin: left top;\n        }\n        :host(:not([dir])) ::slotted(xy-popcon[open]),\n        :host(:not([dir])[trigger="hover"]:not([disabled]):hover) ::slotted(xy-popcon),\n        :host(:not([dir])[trigger="focus"]:not([disabled]):focus-within) ::slotted(xy-popcon),\n        :host([dir="bottomleft"]) ::slotted(xy-popcon[open]),\n        :host([dir="bottomleft"][trigger="hover"]:not([disabled]):hover) ::slotted(xy-popcon),\n        :host([dir="bottomleft"][trigger="focus"]:not([disabled]):focus-within) ::slotted(xy-popcon){\n            transform:translate(0,10px) scale(1);\n        }\n        :host([dir="bottomright"]) ::slotted(xy-popcon){\n            right:0;\n            top:100%;\n            transform:translate(0,10px) scale(0);\n            transform-origin: right top;\n        }\n        :host([dir="bottomright"]) ::slotted(xy-popcon[open]),\n        :host([dir="bottomright"][trigger="hover"]:not([disabled]):hover) ::slotted(xy-popcon),\n        :host([dir="bottomright"][trigger="focus"]:not([disabled]):focus-within) ::slotted(xy-popcon){\n            transform:translate(0,10px) scale(1);\n        }\n        :host([trigger="contextmenu"]) ::slotted(xy-popcon){\n            right:auto;\n            bottom:auto;\n            left:var(--x,0);\n            top:var(--y,100%);\n            transform-origin: left top;\n            transform:translate(5px,5px) scale(0);\n            transition: .15s;\n        }\n        :host([trigger="contextmenu"]) ::slotted(xy-popcon[open]){\n            transform:translate(5px,5px) scale(1);\n        }\n        :host ::slotted(xy-popcon[open]),\n        :host([trigger="hover"]:not([disabled]):hover) ::slotted(xy-popcon),\n        :host([trigger="focus"]:not([disabled]):focus-within) ::slotted(xy-popcon){\n            opacity:1;\n            visibility:visible;\n        }\n        slot{\n            border-radius: inherit;\n        }\n        </style>\n        <slot></slot>\n        ', t;
      }

      return w(e, null, [{
        key: "observedAttributes",
        get: function get() {
          return ["title", "oktext", "canceltext", "loading", "type"];
        }
      }]), w(e, [{
        key: "show",
        value: function value(t) {
          var n = this;
          if (this.popcon = this.querySelector("xy-popcon"), this.disabled) (this.popcon || this).dispatchEvent(new CustomEvent("submit"));else if (this.popcon || (this.popcon = new T(this.type), this.popcon.type = this.type, this.appendChild(this.popcon), this.popcon.title = this.title || "popover", this.popcon.innerHTML = this.content || "", "confirm" == this.type && (this.popcon.oktext = this.oktext || "confirm", this.popcon.canceltext = this.canceltext || "cancel", this.popcon.onsubmit = function () {
            return n.dispatchEvent(new CustomEvent("submit"));
          }, this.popcon.oncancel = function () {
            return n.dispatchEvent(new CustomEvent("cancel"));
          })), "contextmenu" === this.trigger) {
            var e = this.getBoundingClientRect(),
                o = e.x,
                r = e.y;
            this.popcon.style.setProperty("--x", t.clientX - o + "px"), this.popcon.style.setProperty("--y", t.clientY - r + "px"), this.popcon.open = !0;
          } else {
            (t.path || t.composedPath && t.composedPath()).includes(this.popcon) || (window.xyActiveElement = document.activeElement, this.accomplish ? this.popcon.open = !0 : this.popcon.open = !this.popcon.open);
          }
          return this.popcon;
        }
      }, {
        key: "connectedCallback",
        value: function value() {
          var t = this;
          this.popcon = this.querySelector("xy-popcon"), this.trigger && "click" !== this.trigger || this.addEventListener("click", this.show), "contextmenu" === this.trigger && this.addEventListener("contextmenu", function (n) {
            n.preventDefault(), (n.path || n.composedPath && n.composedPath()).includes(t.popcon) || t.show(n);
          }), document.addEventListener("mousedown", function (n) {
            var e = n.path || n.composedPath && n.composedPath();
            (t.popcon && !e.includes(t.popcon) && !t.popcon.loading && !e.includes(t.children[0]) || "contextmenu" === t.trigger && !e.includes(t.popcon) && "1" == n.which) && (t.popcon.open = !1);
          });
        }
      }, {
        key: "attributeChangedCallback",
        value: function value(t, n, e) {
          "loading" == t && this.popcon && (this.popcon.loading = null !== e), "title" == t && this.popcon && null !== e && (this.popcon.title = e), "oktext" == t && this.popcon && null !== e && (this.popcon.oktext = e), "canceltext" == t && this.popcon && null !== e && (this.popcon.canceltext = e);
        }
      }, {
        key: "title",
        get: function get() {
          return this.getAttribute("title") || "popcon";
        },
        set: function set(t) {
          this.setAttribute("title", t);
        }
      }, {
        key: "trigger",
        get: function get() {
          return this.getAttribute("trigger");
        }
      }, {
        key: "disabled",
        get: function get() {
          return null !== this.getAttribute("disabled");
        },
        set: function set(t) {
          null === t || !1 === t ? this.removeAttribute("disabled") : this.setAttribute("disabled", "");
        }
      }, {
        key: "type",
        get: function get() {
          return this.getAttribute("type");
        },
        set: function set(t) {
          this.setAttribute("type", t);
        }
      }, {
        key: "accomplish",
        get: function get() {
          return null !== this.getAttribute("accomplish");
        }
      }, {
        key: "content",
        get: function get() {
          return this.getAttribute("content");
        }
      }, {
        key: "oktext",
        get: function get() {
          return this.getAttribute("oktext");
        },
        set: function set(t) {
          this.setAttribute("oktext", t);
        }
      }, {
        key: "canceltext",
        get: function get() {
          return this.getAttribute("canceltext");
        },
        set: function set(t) {
          this.setAttribute("canceltext", t);
        }
      }, {
        key: "dir",
        get: function get() {
          return this.getAttribute("dir");
        },
        set: function set(t) {
          this.setAttribute("dir", t);
        }
      }, {
        key: "loading",
        get: function get() {
          return null !== this.getAttribute("loading");
        },
        set: function set(t) {
          null === t || !1 === t ? this.removeAttribute("loading") : this.setAttribute("loading", "");
        }
      }]), e;
    }(S(HTMLElement));

    customElements.get("xy-popover") || customElements.define("xy-popover", L);
    e(1);
    var B = e(0);

    function _(t) {
      return (_ = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
        return typeof t;
      } : function (t) {
        return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
      })(t);
    }

    function I(t, n) {
      for (var e = 0; e < n.length; e++) {
        var o = n[e];
        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(t, o.key, o);
      }
    }

    function M(t, n, e) {
      return n && I(t.prototype, n), e && I(t, e), t;
    }

    function z(t, n) {
      return !n || "object" !== _(n) && "function" != typeof n ? function (t) {
        if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return t;
      }(t) : n;
    }

    function F(t) {
      var n = "function" == typeof Map ? new Map() : void 0;
      return (F = function F(t) {
        if (null === t || (e = t, -1 === Function.toString.call(e).indexOf("[native code]"))) return t;
        var e;
        if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function");

        if (void 0 !== n) {
          if (n.has(t)) return n.get(t);
          n.set(t, o);
        }

        function o() {
          return U(t, arguments, H(this).constructor);
        }

        return o.prototype = Object.create(t.prototype, {
          constructor: {
            value: o,
            enumerable: !1,
            writable: !0,
            configurable: !0
          }
        }), N(o, t);
      })(t);
    }

    function U(t, n, e) {
      return (U = D() ? Reflect.construct : function (t, n, e) {
        var o = [null];
        o.push.apply(o, n);
        var r = new (Function.bind.apply(t, o))();
        return e && N(r, e.prototype), r;
      }).apply(null, arguments);
    }

    function D() {
      if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
      if (Reflect.construct.sham) return !1;
      if ("function" == typeof Proxy) return !0;

      try {
        return Date.prototype.toString.call(Reflect.construct(Date, [], function () {})), !0;
      } catch (t) {
        return !1;
      }
    }

    function N(t, n) {
      return (N = Object.setPrototypeOf || function (t, n) {
        return t.__proto__ = n, t;
      })(t, n);
    }

    function H(t) {
      return (H = Object.setPrototypeOf ? Object.getPrototypeOf : function (t) {
        return t.__proto__ || Object.getPrototypeOf(t);
      })(t);
    }

    var J = ["#ff1300", "#EC7878", "#9C27B0", "#673AB7", "#3F51B5", "#0070FF", "#03A9F4", "#00BCD4", "#4CAF50", "#8BC34A", "#CDDC39", "#FFE500", "#FFBF00", "#FF9800", "#795548", "#9E9E9E", "#5A5A5A", "#FFF"],
        V = function (t) {
      !function (t, n) {
        if ("function" != typeof n && null !== n) throw new TypeError("Super expression must either be null or a function");
        t.prototype = Object.create(n && n.prototype, {
          constructor: {
            value: t,
            writable: !0,
            configurable: !0
          }
        }), n && N(t, n);
      }(r, t);
      var n,
          e,
          o = (n = r, e = D(), function () {
        var t,
            o = H(n);

        if (e) {
          var r = H(this).constructor;
          t = Reflect.construct(o, arguments, r);
        } else t = o.apply(this, arguments);

        return z(this, t);
      });

      function r(t) {
        var n;
        !function (t, n) {
          if (!(t instanceof n)) throw new TypeError("Cannot call a class as a function");
        }(this, r);
        var e = (n = o.call(this)).attachShadow({
          mode: "open"
        });
        return n.colorCollections = t.colorCollections || J, n.onColorPicked = t.onColorPicked, n.defaulColor = Object(B.handleCSSVariables)(t.defaultColor || n.colorCollections[0]), n.pluginType = t.type, n.hasCustomPicker = t.hasCustomPicker, n.customColor = Object(B.getCustomColorCache)(n.pluginType), e.innerHTML = '\n        <style>\n        :host{\n            display:inline-block;\n            width:15px;\n            font-size:14px;\n            border: none;\n        }\n        :host([block]){\n            display:block;\n        }\n        :host([disabled]){\n            pointer-events:none;\n        }\n        \n        :host(:focus-within) xy-popover,:host(:hover) xy-popover{ \n            z-index: 2;\n        }\n        input[type="color"]{\n            -webkit-appearance: none;\n            outline: none;\n            border: none;\n        }\n        xy-popover{\n            width:100%;\n            height:35px;\n            margin-right: 3px;\n        }\n        xy-popover:hover {\n            border-radius: 0 5px 5px 0;\n            background: rgba(203, 203, 203, 0.49);\n        }\n        .color-btn {\n            border: 1px solid #cab9b9;\n            margin: 18px 2px 2px 2px;\n            width: 6px;\n            height: 6px;\n            opacity: 0.9;\n            padding: 1px 0 1px 0;\n            color: var(--themeColor, #42b983);\n            background: var(--themeColor, #42b983);\n            font-weight: bolder;\n            border-radius: 2px;\n        }\n        .color-btn:hover {\n            opacity: 1;\n            z-index: auto;\n        }\n        xy-popover{\n            display:block;\n        }\n        xy-popcon{\n            position: fixed;\n            min-width:100%;\n        }\n        #custom-picker {\n            position: relative;\n            top: -1px;\n            background-color: rgb(250, 250, 250);\n            border-color: rgb(255 118 21) rgb(245 80 80 / 74%) #89c1c9 #95d5b6;\n            border-width: 3px;\n            border-radius: 8px;\n            height: 18px;\n        }\n        .pop-footer{\n            display:flex;\n            justify-content:flex-end;\n            padding:0 .8em .8em;\n        }\n        .pop-footer xy-button{\n            font-size: .8em;\n            margin-left: .8em;\n        }\n        .color-btn::before{\n            content:\'\';\n            position:absolute;\n            left:5px;\n            top:5px;\n            right:5px;\n            bottom:5px;\n            z-index:-1;\n            background: linear-gradient(45deg, #ddd 25%,transparent 0,transparent 75%,#ddd 0 ), linear-gradient(45deg, #ddd 25%, transparent 0, transparent 75%, #ddd 0);\n            background-position: 0 0,5px 5px;\n            background-size: 10px 10px;\n        }\n        .color-sign {\n           max-width: 220px;\n           padding: 10px;\n           display:grid;\n           cursor: default;\n           grid-template-columns: repeat(auto-fit, minmax(15px, 1fr));\n           grid-gap: 10px;     \n        }\n        .color-sign>button {\n            position: relative;\n            width: 16px;\n            height: 16px;\n            border-radius: 6px;\n            border: 1px solid #b8b9b49e;\n            outline: 0;\n            opacity: 0.9;\n        }\n        .color-sign>button:hover {\n            cursor: pointer;\n            opacity: 1;\n        }\n        .color-section {\n            display: flex;\n            align-items: center;\n            justify-content: center;\n        }\n        .color-fire-btn {\n            font-size: 17px;\n            font-weight: bold;\n            height: 28px;\n            padding-top: 8px;\n            padding-right: 1px;\n            margin-left: 3px;\n            text-shadow: 2px 0 0 #cab9b9;\n            padding-left: 3px;\n            border-radius: 5px 0 0 5px;\n        }\n        .color-fire-btn:hover {\n            font-size: 17px;\n            font-weight: bold;\n            text-shadow: 2px 0 0 #cab9b9;\n            background: rgba(203, 203, 203, 0.49);\n            border-radius: 5px 0 0 5px;\n        }\n        .color-fire-btn-text {\n            margin-right: 2px;\n        }\n        </style>\n        <section class="color-section">\n            <div class="color-fire-btn" id="color-fire-btn">\n                '.concat("marker" === n.pluginType ? '\n    <div class="marker-icon">\n        <svg height="13px" width="14px" viewBox="1 0 511.99849 511"  xmlns="http://www.w3.org/2000/svg"><path d="m111.707031 269.585938 186.09375-186.09375 131.203125 131.203124-186.09375 186.09375zm0 0"/><path d="m319.027344 62.265625 61.769531-61.765625 131.203125 131.203125-61.769531 61.765625zm0 0"/><path d="m0 469.4375 42.484375-42.488281 43.058594 43.058593-42.484375 42.484376zm0 0"/><path d="m130.125 472.140625 33.003906-33.003906 57.730469-17.957031-129.539063-129.539063-17.960937 57.726563-33.003906 33.007812zm0 0"/></svg>\n    </div>' : '<div class="color-fire-btn-text">A</div>', '\n            </div>\n            <xy-popover id="popover" ').concat(n.dir ? "dir='" + n.dir + "'" : "", '>\n                <xy-button class="color-btn" id="color-btn" ').concat(n.disabled ? "disabled" : "", '>_</xy-button>\n                <xy-popcon id="popcon">\n                    <div class="color-sign" id="colors">\n                        ').concat(n.hasCustomPicker ? '<button id="custom-picker" class="rainbow-mask"/>' : "", "\n                        ").concat(n.colorCollections.map(function (t) {
          return '<button style="background-color:' + t + '" data-color=' + t + "></button>";
        }).join(""), "\n                    </div>\n                </xy-popcon>\n            </xy-popover>\n        </section>"), n;
      }

      return M(r, null, [{
        key: "observedAttributes",
        get: function get() {
          return ["disabled", "dir"];
        }
      }]), M(r, [{
        key: "focus",
        value: function value() {
          this.colorBtn.focus();
        }
      }, {
        key: "connectedCallback",
        value: function value() {
          var t = this;
          this.popover = this.shadowRoot.getElementById("popover"), this.popcon = this.shadowRoot.getElementById("popcon"), this.colorBtn = this.shadowRoot.getElementById("color-btn"), this.colors = this.shadowRoot.getElementById("colors"), this.colors.addEventListener("click", function (n) {
            var e = n.target.closest("button");
            e && "custom-picker" !== e.id && (t.nativeclick = !0, t.value = Object(B.handleCSSVariables)(e.dataset.color), t.onColorPicked(t.value));
          }), this.hasCustomPicker && this.setupCustomPicker(), this.value = this.defaultvalue;
        }
      }, {
        key: "disconnectedCallback",
        value: function value() {
          this.pickerInput && document.body.removeChild(this.pickerInput);
        }
      }, {
        key: "setupCustomPicker",
        value: function value() {
          var t = this,
              n = !1;
          this.customPicker = this.shadowRoot.getElementById("custom-picker");
          var e = this.customPicker;
          e.style.backgroundColor = this.customColor, this.customPicker.addEventListener("click", function (o) {
            if (n) n = !1;else {
              t.pickerInput && document.body.removeChild(t.pickerInput), t.pickerInput = document.createElement("input");
              var r = t.pickerInput,
                  i = t.popcon.getBoundingClientRect();
              r.setAttribute("type", "color"), r.value = t.customColor, r.style.position = "fixed", r.style.left = "".concat(i.x + 3, "px"), r.style.top = "".concat(i.y + 10, "px"), r.style.pointerEvents = "none", r.style.zIndex = "999", r.style.opacity = "0", r.addEventListener("input", Object(B.throttle)(function (o) {
                t.nativeclick = !0, t.value = Object(B.handleCSSVariables)(o.target.value), t.onColorPicked(t.value), Object(B.setCustomColorCache)(t.value, t.pluginType), e.style.backgroundColor = t.value, n = !0, e.click();
              }, 30)), document.body.appendChild(r), setTimeout(function () {
                r.focus(), r.click();
              }, 0);
            }
          });
        }
      }, {
        key: "attributeChangedCallback",
        value: function value(t, n, e) {
          "disabled" == t && this.colorBtn && (null != e ? this.colorBtn.setAttribute("disabled", "disabled") : this.colorBtn.removeAttribute("disabled")), "dir" == t && this.popover && null != e && (this.popover.dir = e);
        }
      }, {
        key: "defaultvalue",
        get: function get() {
          return this.defaulColor;
        },
        set: function set(t) {
          this.setAttribute("defaultvalue", t);
        }
      }, {
        key: "value",
        get: function get() {
          return this.$value;
        },
        set: function set(t) {
          t && (this.$value = t, this.colorBtn.style.setProperty("--themeColor", this.nativeclick ? Object(B.setDefaultColorCache)(t, this.pluginType) : Object(B.getDefaultColorCache)(t, this.pluginType)), this.nativeclick ? (this.nativeclick = !1, this.dispatchEvent(new CustomEvent("change", {
            detail: {
              value: this.value
            }
          }))) : this.colorPane ? this.colorPane.value = this.value : this.defaultvalue = this.value);
        }
      }, {
        key: "type",
        get: function get() {
          return this.getAttribute("type");
        }
      }, {
        key: "disabled",
        get: function get() {
          return null !== this.getAttribute("disabled");
        },
        set: function set(t) {
          null === t || !1 === t ? this.removeAttribute("disabled") : this.setAttribute("disabled", "");
        }
      }, {
        key: "dir",
        get: function get() {
          return this.getAttribute("dir");
        },
        set: function set(t) {
          this.setAttribute("dir", t);
        }
      }]), r;
    }(F(HTMLElement));

    customElements.get("xy-color-picker") || customElements.define("xy-color-picker", V);
  }]);
});